import { Ellipsis } from 'lucide-react';
import { useState } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { Order } from '../../../../order.types';
import MoreActionsMenu from './MoreActionsMenu';
import OrderSummaryActionButton from './OrderSummaryActionButton';

interface MoreActionsButtonProps {
  order?: Order;
  disabled: boolean;
}

const MoreActionsButton = ({ order, disabled }: MoreActionsButtonProps) => {
  const [moreActionsAnchorEl, setMoreActionsAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <OrderSummaryActionButton
        label={LangEnum.GLOBAL_MORE_ACTIONS}
        onClick={(event) => setMoreActionsAnchorEl(event.currentTarget || null)}
        ActionIcon={Ellipsis}
        disabled={disabled}
      />

      {order && (
        <MoreActionsMenu
          moreActionsAnchorEl={moreActionsAnchorEl}
          onClickMoreActions={(event) => setMoreActionsAnchorEl(event?.currentTarget || null)}
          order={order}
        />
      )}
    </>
  );
};

export default MoreActionsButton;
